import deck from "../data/deck.json";
/*
import { useState } from "react";
import {useParams} from 'react-router-dom';
const {id} = useParams();
*/
import Shuffle from "../components/Shuffle";
export default Shuffle(deck);
